export const TERMINALS_DATA = {
  "ams1": {
    slug: "ams1",
    name: "AMS1",
    tagline: "Terminal mobile Android tout-en-un",
    description: "Concu pour promouvoir des parcours de paiement rapides et mobiles. Acceptez les paiements et gerez vos applications professionnelles depuis un seul appareil.",
    category: "Mobile",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL0tpOUNxS0hUYlJmSjhkcGtjQmg5LnBuZyJ9:adyen:dufuGgNmmkJjZPHNly2x-MwLDTDTqNoGNGU08S0kiUo?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL0FWeTZlVzhYYktKVUhrdlFxQmVkLmpwZyJ9:adyen:WLgQeG145JPPOKcLWBr6wYQp3kN5BJa2Bu80kb4O0gk?format=webp&width=800&height=600",
    highlights: [
      "Un seul appareil pour paiements et applications metier",
      "Reduisez les files d'attente en acceptant les paiements partout",
      "Batterie longue duree pour une journee complete",
      "Montage facile sur comptoir ou utilisation mobile"
    ],
    specs: {
      dimensions: "122 x 67 x 18 mm",
      poids: "170g",
      ecran: "Ecran tactile 4 pouces",
      imprimante: "Non",
      batterie: "2598 mAh (10Wh), remplacable",
      processeur: "Quad-core, 1.3 GHz, ARM Cortex-A7",
      memoire: "16 Go Flash / 2 Go RAM",
      os: "Android 10",
      camera: "Camera integree",
      pci: "PCI PTS 6",
      p2pe: "Disponible (firmware 1.117+)"
    },
    connectivity: {
      ethernet: false,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "Mode hors-ligne",
      "Mode autonome"
    ]
  },
  "sfo1": {
    slug: "sfo1",
    name: "SFO1",
    tagline: "Terminal comptoir avec ecran client",
    description: "Paiement, branding et engagement client — tout dans un seul terminal. Ecran 8 pouces haute resolution pour une experience client premium.",
    category: "Comptoir",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcLzM0cVBmajMzVkJzZ1dOWmVpdlF6LnBuZyJ9:adyen:4_pKNLE6udwQyZHL-3oepPpqofV7c_dozQ_b264dvHM?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL010SlJqSEpEdHpNYjZwRE5IYWdELmpwZyJ9:adyen:lnQNwG_ZRBS9c7IxxqA-L1Wlw4CupLLWDELfSuZDErc?format=webp&width=800&height=600",
    highlights: [
      "Ecran 8 pouces pour affichage personnalise de votre marque",
      "Consolidez plusieurs appareils en un seul",
      "Promotions et programmes de fidelite integres",
      "Montage comptoir, pole ou mural"
    ],
    specs: {
      dimensions: "203 x 144.4 x 18.25 mm",
      poids: "414g",
      ecran: "8\" IPS 1280x800 capacitif tactile",
      imprimante: "Non",
      batterie: "Non applicable (alimentation secteur)",
      processeur: "Quad-Core ARM Cortex-A53",
      memoire: "64 Go Flash / 4 Go RAM",
      os: "Adyen OS base sur Android 13",
      camera: "Camera frontale 5MP",
      pci: "PCI PTS 6",
      p2pe: "Non disponible"
    },
    connectivity: {
      ethernet: true,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "Ecran et logo personnalisables",
      "Mode hors-ligne",
      "Mode autonome",
      "Wallet Passes (AppleVAS)"
    ]
  },
  "nyc1": {
    slug: "nyc1",
    name: "NYC1",
    tagline: "Lecteur de cartes compact et mobile",
    description: "Un lecteur de cartes compact et primie (Red Dot Award, iF Design Award) pour les entreprises en mouvement. Batterie longue duree et connexion Bluetooth simple.",
    category: "Mobile",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL2IzREdwSzRzMmpSV0NYZFJteHo5LnBuZyJ9:adyen:PItds0nupqldFNFSHXLFJvhoGof3pmEmtuxz-1lEsu4?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL3VZYXFFcXRaYWpIQWhNOVkzcnBnLmpwZyJ9:adyen:hvJlt4ElgPS__UAQlPot3DHPg7cx7xdOKwAr1QmpfFc?format=webp&width=800&height=600",
    highlights: [
      "Batterie longue duree pour les journees les plus chargees",
      "Connexion facile via Bluetooth avec votre appareil mobile",
      "Acceptez les paiements par carte, NFC et puce",
      "Design compact primie (Red Dot + iF Design Award)"
    ],
    specs: {
      dimensions: "94 x 70 x 13 mm",
      poids: "92g",
      ecran: "Non applicable",
      imprimante: "Non",
      batterie: "500 mAh, 3.7V",
      processeur: "MH1903",
      memoire: "8 Mo Flash / 1 Mo RAM",
      os: "Non applicable",
      camera: "Non applicable",
      pci: "PCI PTS 6",
      p2pe: "Non applicable"
    },
    connectivity: {
      ethernet: false,
      cellular: false,
      wifi: false,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Puce et bande magnetique",
      "Apple Pay / Google Pay",
      "Cartes cadeaux",
      "Pourboire",
      "Moyens de paiement locaux (Twint)"
    ]
  },
  "s1f2": {
    slug: "s1f2",
    name: "S1F2",
    tagline: "Terminal Android avec imprimante integree",
    description: "Un appareil Android tout-en-un avec imprimante integree. Acceptez les paiements, imprimez les recus et gerez vos applications — tout depuis un seul terminal portable.",
    category: "Mobile",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL0pkUVoySEZ1VjhkVXRrR1pXNkJOLnBuZyJ9:adyen:9JEWptYxavUFw4vCOvtLSHBhds-Sy4FBjOEZDmV2Xvw?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL3VZeWdvaG5TNmRmQnNXRXlnV2RxLmpwZyJ9:adyen:w40uF20JF-CmK3X91enBEjkQLFAKJsuEVEBFMUkERYI?format=webp&width=800&height=600",
    highlights: [
      "Imprimante integree pour les recus",
      "Ecran tactile 5.5 pouces",
      "Camera 5MP et lecteur de codes-barres",
      "Batterie longue duree 5840 mAh"
    ],
    specs: {
      dimensions: "200 x 78 x 56 mm",
      poids: "495g",
      ecran: "Ecran tactile 5.5 pouces",
      imprimante: "Oui (rouleau 40mm)",
      batterie: "5840 mAh (21.3Wh), remplacable",
      processeur: "Quad-core, 1.3 GHz, ARM Cortex-A7",
      memoire: "16 Go Flash / 2 Go RAM",
      os: "Android 9.0 / Android 10",
      camera: "Camera 5MP + lecteur codes-barres optionnel",
      pci: "PCI PTS 6",
      p2pe: "Disponible (firmware 1.117+)"
    },
    connectivity: {
      ethernet: false,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "Mode hors-ligne",
      "Mode autonome",
      "Pay@Table",
      "Cashback"
    ]
  },
  "p630": {
    slug: "p630",
    name: "P630",
    tagline: "Terminal comptoir premium et fiable",
    description: "Design premium, fonctionnalites completes et ultra-fiable. Ecran tactile avec Gorilla Glass, connectivite complete et pret pour le self-service.",
    category: "Comptoir",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL3pNZjdpNThRbnJ0RmpWUGdZcWhjLnBuZyJ9:adyen:qMAPufZNB64fyeOiZ5D5uAsPS6L4BwQrgjBAavYR6K4?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL0xqQ2FjZlpkcWNHU01ROGc1aXRtLmpwZyJ9:adyen:Eq072rTMuJ2JEZINaeQi4d2rdAy3BqysmZGFXFnWDSY?format=webp&width=800&height=600",
    highlights: [
      "Ecran tactile 3.5\" avec Corning Gorilla Glass",
      "Connectivite complete : WiFi, Ethernet, Bluetooth",
      "Pret pour le self-service et les kiosques",
      "Pre-configure et pret a l'emploi en quelques minutes"
    ],
    specs: {
      dimensions: "170 x 80 x 32 mm",
      poids: "310g",
      ecran: "3.5\" HVGA capacitif avec Corning Gorilla Glass",
      imprimante: "Non",
      batterie: "Non disponible (alimentation secteur)",
      processeur: "Qualcomm Cortex A53 Quad-Core 1.3 GHz",
      memoire: "8 Go Flash / 1 Go RAM (MicroSD jusqu'a 128 Go)",
      os: "Android 10",
      camera: "Non disponible",
      pci: "PCI PTS 6",
      p2pe: "Disponible"
    },
    connectivity: {
      ethernet: true,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "Ecran et logo personnalisables",
      "Mode hors-ligne",
      "Mode autonome",
      "Self-service"
    ]
  },
  "m450": {
    slug: "m450",
    name: "M450",
    tagline: "Terminal comptoir grand ecran HD",
    description: "Impact, insights et interactions bidirectionnelles. Ecran tactile HD 8 pouces pour une experience client immersive avec affichage personnalise, publicites et programmes de fidelite.",
    category: "Comptoir",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcLzN4WlVLNTRTRDNNNThLTHZMRGtMLnBuZyJ9:adyen:zbH86lvJdp8wb4wEN_dwe02ZPFy9S-bxaQ-2UlpPv9w?format=webp&width=500&height=666",
    lifestyle: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL0xqQ2FjZlpkcWNHU01ROGc1aXRtLmpwZyJ9:adyen:Eq072rTMuJ2JEZINaeQi4d2rdAy3BqysmZGFXFnWDSY?format=webp&width=800&height=600",
    highlights: [
      "Ecran tactile HD 8 pouces pour affichage dynamique",
      "Entierement personnalisable (logos, publicites, fidelite)",
      "Pre-configure : deballer, brancher, c'est pret",
      "Camera frontale 5MP et connectivite complete"
    ],
    specs: {
      dimensions: "201.25 x 210.8 x 29.2 mm",
      poids: "629g",
      ecran: "8\" tactile HD",
      imprimante: "Non",
      batterie: "Non applicable (alimentation secteur)",
      processeur: "A53 Quad-Core 1.3 GHz",
      memoire: "16 Go Flash / 2 Go RAM (slot SD)",
      os: "Android 10",
      camera: "Camera frontale 5MP",
      pci: "PCI PTS 6",
      p2pe: "Disponible"
    },
    connectivity: {
      ethernet: true,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "Ecran et logo personnalisables",
      "Mode hors-ligne",
      "Mode autonome",
      "Wallet Passes (AppleVAS)",
      "Signature digitale",
      "Programmes de fidelite"
    ]
  },
  "s1e2l": {
    slug: "s1e2l",
    name: "S1E2L",
    tagline: "Terminal mobile Android fin et puissant",
    description: "Elegant, durable et mobile. Un appareil Android tout-en-un avec ecran tactile 5 pouces, processeur octa-core et batterie longue duree pour une journee complete d'utilisation intensive.",
    category: "Mobile",
    image: "https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYWR5ZW5cL2ZpbGVcL1djMVFDTTF0U2NHTDZ4Sml3N2o0LnBuZyJ9:adyen:_zMomdQWR15y5m7MQvq7qmiksXeVXx1LNgi74Chotps?format=webp&width=500&height=666",
    lifestyle: "https://customer-assets.emergentagent.com/job_payment-links-hub-1/artifacts/rthwn6dc_Capture%20d%E2%80%99e%CC%81cran%202026-05-10%20a%CC%80%2001.17.35.png",
    highlights: [
      "Ecran tactile 5 pouces avec PIN sur verre",
      "Processeur octa-core haute performance",
      "Batterie 6000 mAh pour toute la journee",
      "Camera 5MP + lecteur de codes-barres + empreinte digitale"
    ],
    specs: {
      dimensions: "169 x 75 x 18 mm",
      poids: "262g",
      ecran: "Ecran tactile 5 pouces",
      imprimante: "Non",
      batterie: "6000 mAh / 3.75V",
      processeur: "Octa-core Cortex-A53 1.8 GHz",
      memoire: "16 Go Flash / 2 Go RAM",
      os: "Android 10",
      camera: "Camera 5MP + lecteur codes-barres + empreinte digitale",
      pci: "PCI PTS 6",
      p2pe: "Disponible (firmware 1.117+)"
    },
    connectivity: {
      ethernet: false,
      cellular: true,
      wifi: true,
      bluetooth: true
    },
    payments: [
      "Cartes bancaires (debit/credit)",
      "Sans contact (NFC)",
      "Cartes cadeaux",
      "Moyens de paiement locaux (Twint)",
      "QR codes",
      "Apple Pay / Google Pay",
      "Pourboire",
      "Conversion de devise (DCC)",
      "PIN sur verre",
      "Mode hors-ligne",
      "Mode autonome",
      "Pay@Table",
      "Cashback"
    ]
  }
};

export const TERMINAL_SLUGS = Object.keys(TERMINALS_DATA);
